import { render, staticRenderFns } from "./kitEmbalagens.vue?vue&type=template&id=ddb8b37c"
import script from "./kitEmbalagens.ts?vue&type=script&lang=js&external"
export * from "./kitEmbalagens.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddb8b37c')) {
      api.createRecord('ddb8b37c', component.options)
    } else {
      api.reload('ddb8b37c', component.options)
    }
    module.hot.accept("./kitEmbalagens.vue?vue&type=template&id=ddb8b37c", function () {
      api.rerender('ddb8b37c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/fracionaEstoque/kitEmbalagens.vue"
export default component.exports